export const IMAGE_UPLOADER_STORAGE =
  "https://storage.gawegawe.id/upload";
